<template>
  <section>
    <div class="left">
      <h2 v-translate>Nastavení výchozích uživatelských profilů</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <select-box
            id="create_default_child_subscriber_profile"
            :options="nullableBooleanOptions"
            v-model="createDefaultChildSubscriberProfile"
            :disabled="!isEditable"
            ref="createdefaultchildsubscriberprofileref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: adminCreateDefaultChildProfileValueText })"
        >
          <translate class="translate">Vytvářet výchozí dětský profil</translate>
        </select-box>
        <checkbox-input
            v-if="isOperator"
            :disabled="!isEditable"
            id="subscriber_profile_autoselect_on_new_device"
            v-model="entity.subscriber_profile_autoselect_on_new_device"
        >
          <translate class="translate">Automaticky předvybrat poslední použitý profil u nových zařízení</translate>
        </checkbox-input>
      </div>
      <div class="field_right">
        <text-input
            id="default_subscriber_profile_name"
            v-model="entity.default_subscriber_profile_name"
            :disabled="!isEditable"
            ref="defaultsubscriberprofilenameref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: entity.admin_default_subscriber_profile_name })"
        ><translate class="translate">Název výchozího uživatelského profilu</translate></text-input>
        <text-input
            id="default_child_subscriber_profile_name"
            v-model="entity.default_child_subscriber_profile_name"
            :disabled="!isEditable"
            ref="defaultchildsubscriberprofilenameref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: entity.admin_default_child_subscriber_profile_name })"
        ><translate class="translate">Název výchozího dětského uživatelského profilu</translate></text-input>
      </div>
    </div>
  </section>
</template>
<script>
import {getCorrectBooleanValue} from "@/utils/helpers"

export default {
  name: "SubscriberProfileForm",
  props: {
    entity: Object,
    isOperator: Boolean,
    isEditable: Boolean,
  },
  computed:{
    nullableBooleanOptions() {
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    createDefaultChildSubscriberProfile:{
      get() {
        return this.entity.create_default_child_subscriber_profile
      },
      set(newValue) {
        this.entity.create_default_child_subscriber_profile = getCorrectBooleanValue(newValue)
      }
    },
    helptext(){
      return this.isOperator
        ? this.$gettext('Hodnota nastavení business modelu/platformy: %{value}')
        : this.$gettext('Hodnota nastavení platformy: %{value}')
    },
    adminCreateDefaultChildProfileValueText(){
      return this.entity.admin_create_default_child_subscriber_profile ? this.$gettext('Ano') : this.$gettext('Ne');
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/views/businessModels/Forms/SubscriberProfileForm.vue